import React from 'react';
const EventComponent = ({ event }) => {
  return (
    <div className='event-content'>
      <div>
        <span className="title">KursKod: </span>
        <span>{event.kursKod}</span>
      </div>
      <div>
        <span className="title">Lokal: </span>
        <span>{event.lokaler.join(', ')}</span>
      </div>
      <div>
        <span className="title">KursNamn: </span>
        <span>{event.kursNamn}</span>
      </div>
      <div>
        <span className="title">moment: </span>
        <span>{event.moment}</span>
      </div>
      </div>
  );
};
export default EventComponent